export const permissionKeys = {
  list_permissions: () => ['permissions'] as const,
  list_roles: () => ['roles'] as const,
  system_permissions: () => ['system-permissions'] as const,
}
